<template>
  <div class="scan_index_warp">
    <div class="card">
      <p class="title">UTM推广</p>
      <p ><span class="desc">推广名称：</span><span>{{formData.utmName}}</span></p>
      <p ><span class="desc">分享类型：</span><span>{{accountStatusList[formData.utmMethodTypeEvar]}}</span></p>
      <p ><span class="desc">ID：</span><span>{{formData.shareEntityId || formData.shareUrl}}</span></p>
      <p ><span class="desc">分享方式：</span><span>{{formData.utmShareTypeEvar}}</span></p>
      <p ><span class="desc">用户类型：</span><span>{{formData.utmCustomerTypeEvar}}</span></p>
      <p ><span class="desc">分享人ID：</span><span>{{formData.shareUserName}}</span></p>
      <p><span class="desc">分享ID：</span><span>{{formData.id}}</span></p>
      <p ><span class="desc">分享TIME：</span><span>{{formData.utmTime}}</span></p>
      <p ><span class="desc">分享媒介：</span><span>{{formData.utmMediumTypeEvar}}</span></p>
      <p ><span class="desc">分享来源：</span><span>{{formData.utmSourceTypeEvar}}</span></p>
    </div>
  </div>  
</template>  
<script>
export default {
  data(){
    return{
      formData:{},
      accountStatusList:{}
    }
  },
  methods:{
    getUtmDetails(){
      let id = this.$route.query.shortCode || this.$route.query.id
      this.http({
        method:'get',
        url:'/order/admin/utm/scan/'+id
      }).then(rps=>{
        if(rps.code ==200){
          this.formData = rps.data;
        }
      })
    },
    getTypes(){
      this.http({
        method:'get',
        url:'order/admin/utm/manageShareType'
      }).then(rps=>{
        if(rps.code ==200){
          this.accountStatusList = rps.data;
        }
      })
    }
  },
  created(){
    this.$loading.hide();
    this.getTypes();
    if(this.$route.query.id || this.$route.query.shortCode){
      this.getUtmDetails()
    }
  }
}
</script>
<style lang="less" scoped>
  .scan_index_warp{
    background: #f5f5f5;
    .card{
      margin: 20px 30px;
      padding: 30px;
      background: #FFFFFF;
      border-radius: 10px;
      font-size: 24px;
      color: #333;
      min-height: 90vh;
      p{
        padding-top: 40px;
      }
      .title{
        text-align: center;
        font-size: 32px;
        color: #333;
        padding-bottom: 20px;
        font-weight: 500;
        border-bottom: 1PX solid #ddd;
      }
      .desc{
        font-size: 24px;
        text-align: right;
        width: 137px;
        display: inline-block;
        color: #999;
      }
    }
  }
</style>